import { Directive, HostListener, inject } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appDateMaskDirective]',
  standalone: true,
})
export class PaymentDateMaskDirective {
  private readonly control = inject(NgControl);
  @HostListener('input', ['$event'])
  onInput(event: Event) {
    const input = event.target as HTMLInputElement;
    if (!input) return;

    const value = input.value;

    let cleaned = value.replace(/\D/g, '');

    if (cleaned.length === 1 && parseInt(cleaned, 10) > 1) {
      cleaned = '0' + cleaned;
    }

    if (cleaned.length > 2) {
      cleaned = cleaned.slice(0, 2) + '/' + cleaned.slice(2, 4);
    } else {
      cleaned = cleaned.slice(0, 2);
    }

    input.value = cleaned;

    this.control.control?.setValue(cleaned, {
      emitEvent: false,
      emitModelToViewChange: false,
    });
  }
}
